import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cn from '../../../../lib/bem';
import {
  updateCorreoTermino,
  postCotizacionEnviar,
} from '../../../../redux/reducers/simuladorFVGSlice';
import ico_cancel_circle from './../../../../assets/svg/ico_cancel_circle.svg';
import InputTextEditComponent from '../../../../components/inputTextEdit/inputTextEdit_component';
import InputCheckComponent from '../../../../components/inputCheck/inputCheck_component';
import ButtonComponent from '../../../../components/button/button_component';
import img_persona_laptop from './../../../../assets/svg/img_persona_laptop.svg';
import { validarCorreo } from '../../../../lib/utils';

import './modalConfirmarCorreo_Component.scss';

const ModalConfirmarCorreoComponent = (props) => {
  const classes = cn('modalConfirmarCorreoComponent');
  const dispatch = useDispatch();

  const simuladorFVG = useSelector((state) => state.rootReducers.simuladorFVG);
  const [correoEle, guardarCorreoEle] = useState(simuladorFVG.correoEle);
  const [msgTerminos, guardarMsgTerminos] = useState('');
  const [msgCorreoEle, guardarMsgCorreoEle] = useState('');
  const [terminos, guardarTerminos] = useState(simuladorFVG.terminos);

  const onClickGuardarDatos = () => {
    if (correoEle.trim() === '') {
      guardarMsgCorreoEle('El campo es obligatorio');
      return false;
    }

    if (!validarCorreo(correoEle.trim())) {
      guardarMsgCorreoEle('El campo debe ser un correo electrónico válido');
      return false;
    }

    if (!terminos) {
      guardarMsgTerminos('Debe aceptar las condiciones establecidas');
      return false;
    }

    dispatch(
      postCotizacionEnviar({
        idSimulacion: simuladorFVG.idSimulacion,
        idCotizacion: simuladorFVG.idCotizacion,
        correo: correoEle,
      })
    ).then((resp) => {
      props.onClose(false);
    });

    dispatch(
      updateCorreoTermino({
        correoEle: correoEle,
        terminos: terminos,
      })
    );
  };

  return (
    <div className={classes()}>
      <div className={classes('container')}>
        <div className={classes('content')}>
          <div className={classes('contentImg')}>
            <img src={img_persona_laptop} alt="img_persona_laptop" />
          </div>
          <div className={classes('contentForm')}>
            <img
              className={classes('contentClose')}
              src={ico_cancel_circle}
              alt={'ico_cancel_circle'}
              onClick={() => props.onClose(false)}
            />
            <p className={classes('contentTitle')}>
              <b>Confirma tu correo</b>
            </p>
            <p className={classes('contentSubTitle')}>
              Confirmanos tu correo para el envío de la simulación
            </p>
            <div>
              <InputTextEditComponent
                inputText={'Correo'}
                inputValue={correoEle}
                inputAction={guardarCorreoEle}
                inputWidth={100}
                type={''}
                inputMsg={msgCorreoEle}
                inputActionMsg={guardarMsgCorreoEle}
                styleText={''}
              />
              <InputCheckComponent
                inputValue={terminos}
                inputAction={guardarTerminos}
                inputText={[
                  <a
                    key={'linkTerminos'}
                    className={classes('inputCheckLink')}
                    target="_blank"
                    href="https://www.pacifico.com.pe/terminos-condiciones-ecommerce"
                    rel="noreferrer"
                  >
                    {' '}
                    He leído y acepto las condiciones establecidas en la
                    cláusula de{' '}
                    <span className={classes('inputCheckSpan')}>
                      protección de datos personales.
                    </span>
                  </a>,
                ]}
              />
              {msgTerminos && (
                <label className={classes('inputCheckLabelError')}>
                  {msgTerminos}
                </label>
              )}
              <div className={classes('contentButton')}>
                <ButtonComponent
                  label={'btnContinuarRegistro'}
                  tipo={'button-red'}
                  disabled={correoEle === '' || terminos === false}
                  action={onClickGuardarDatos}
                  nombre={'Continuar'}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalConfirmarCorreoComponent;
